import script from "./AuditLogViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLogViewer.vue?vue&type=script&setup=true&lang=js"

import "./AuditLogViewer.vue?vue&type=style&index=0&id=23424886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23424886"]])

export default __exports__